export function addTranslateHotkey(hotkeys, fdTranslate, translateModalService) {
  'ngInject';
  if (fdTranslate.options.hotkey) {
    hotkeys.add({
      combo: 'ctrl+t',
      description: 'Add new translation',
      callback: () => {
        translateModalService.open();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-translate/src/translate.hotkey.js